import classNames from 'classnames/bind';

import Styles from '../story-filters-styles.module.scss';

const cx = classNames.bind(Styles);

const ResetButtonInfo = ({ hasBigScreenDesign }) => (
  <div className={cx('story-filter__btn-reset--inner')}>
    <p
      className={cx('story-filter__btn-reset--value', { big_screen: hasBigScreenDesign })}
    >
      Reset
    </p>
  </div>
);

export default ResetButtonInfo;
